export default __webpack_public_path__ + "static/media/help--download-spreadsheet.e388285a.png";